import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ViewerComponent } from './fi-checklist2-viewer.component';
import { FormsModule } from '@angular/forms';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatRadioModule } from '@angular/material/radio';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatButtonModule } from '@angular/material/button';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { FiChecklist2ViewerAnswerStatusComponent } from '@fi-shared/checklist/fi-checklist2-viewer/answer-status/answer-status.component';
import { MatInputModule } from '@angular/material/input';
import { FiCircularGradientProgressBarModule } from '@fi-shared/fi-circular-gradient-progress-bar/fi-circular-gradient-progress-bar.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiChecklist2ViewerMenuComponent } from '@fi-shared/checklist/fi-checklist2-viewer/viewer-menu/viewer-menu.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiChecklist2ViewerStatusComponent } from '@fi-shared/checklist/fi-checklist2-viewer/viewer-status/viewer-status.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { FiChecklist2AuditOnDemandUnitSharingSettingsComponent } from '@fi-shared/checklist/fi-checklist2-viewer/audit-on-demand-unit-sharing-settings/audit-on-demand-unit-sharing-settings.component';
import { FiChecklist2ViewerUnitSelectorComponent } from '@fi-shared/checklist/fi-checklist2-viewer/checklist-viewer-unit-selector/checklist-viewer-unit-selector.component';
import { FiChecklist2ViewerScheduleNotShared } from '@fi-shared/checklist/fi-checklist2-viewer/checklist-viewer-schedule-not-shared/checklist-viewer-schedule-not-shared.component';
import { FiChecklist2ViewerDisabledViewerWarningSnackbarComponent } from '@fi-shared/checklist/fi-checklist2-viewer/disabled-viewer-warning-snackbar/disabled-viewer-warning-snackbar.component';
import { FiGradientTimerModule } from '@fi-shared/fi-gradient-timer/fi-gradient-timer.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { FiChecklist2ViewerCheckpointGroupComponent } from '@fi-shared/checklist/fi-checklist2-viewer/checkpoint-group/checkpoint-group.component';
import { FiChecklist2AnswerComponent } from '@fi-shared/checklist/fi-checklist2-viewer/answer/answer.component';
import { FiChecklist2AnswerLogComponent } from '@fi-shared/checklist/fi-checklist2-viewer/answer/answer-log/answer-log.component';
import { FiNumberOnlyModule } from '@fi-shared/fi-directives/number-only/number-only.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiValidatingFormModule,
        MatRadioModule,
        FiAppTextSharedModule,
        MatCheckboxModule,
        FiAttachmentsModule,
        MatButtonModule,
        FiErrorMessageModule,
        FiFormatDateModule,
        FiTwoColumnsContainerModule,
        MatIconModule,
        MatMenuModule,
        MatCardModule,
        MatInputModule,
        FiCircularGradientProgressBarModule,
        MatDividerModule,
        InfoIconModule,
        FiIconTooltipButtonModule,
        FiProfileIconModule,
        FiMatIconCheckboxMenuModule,
        SelectSearchModule,
        FiToggleSwitchModule,
        FiGradientTimerModule,
        FiBindHtmlCompileModule,
        FiDirectivesModule,
        FiNumberOnlyModule,
    ],
    declarations: [
        FiChecklist2ViewerComponent,
        FiChecklist2AnswerComponent,
        FiChecklist2ViewerCheckpointGroupComponent,
        FiChecklist2ViewerAnswerStatusComponent,
        FiChecklist2ViewerMenuComponent,
        FiChecklist2ViewerStatusComponent,
        FiChecklist2AnswerLogComponent,
        FiChecklist2AuditOnDemandUnitSharingSettingsComponent,
        FiChecklist2ViewerUnitSelectorComponent,
        FiChecklist2ViewerScheduleNotShared,
        FiChecklist2ViewerDisabledViewerWarningSnackbarComponent,
    ],
    exports: [FiChecklist2ViewerComponent],
})
export class FiChecklist2ViewerModule {}
